import { http } from "api/http";

const getGstrBulkSyncStatus = () => {
  return http.get("/gstr-config/bulkSyncStatus");
};

const updateGstrEnableStatus = () => {
  return http.put(`/gstr-config/enableStatus`);
};

const updateGstrDisableStatus = () => {
  return http.put(`/gstr-config/disableStatus`);
};

const gstrScheduling = (data: any) => {
  return http.post(`/gstr-config/scheduling`, data);
};

const disableGstrClient = (id: number) => {
  return http.put(`/gstr-config/disableGstr/${id}`);
};

const disableAtomProGstrClients = (data: any) => {
  return http.put("/gstr-config/disableGstrClients", data);
};

const getDeletedGstrClients = ({ queryKey }) => {
  let { limit, offset, sort, search, query } = queryKey[1] || {};
  return http.get("/gstr-config/deletedGstrClients", {
    params: {
      limit,
      offset,
      sort,
      search,
      ...query,
    },
  });
};

const exportdeletedGstClient = (data) => {
  return http.post("/gstr-config/export-deletedGstrClients", data);
};

const enableGstrClient = (id) => {
  return http.put(`/gstr-config/enableGstr/${id}`);
};

const getGstAtomClient = ({ queryKey }: any) => {
  return http.get(`/gstr-config/atom-client/${queryKey[1]}`);
};

const createNoticeAndOrder = (data: any) => {
  return http.post(`/gstr-config/noticeAndOrder`, data);
};

const updateNoticeAndOrder = (data: any) => {
  return http.put(`/gstr-config/noticeAndOrder`, data);
};

const deleteNoticeAndOrder = ({ id }) => {
  return http.delete(`/gstr-config/noticeAndOrder/${id}`);
};

const createAdditionalNotice = (data: any) => {
  return http.post(`/gstr-config/additionalNotice`, data);
};

const updateAdditionalNotice = (data: any) => {
  return http.put(`/gstr-config/additionalNotice`, data);
};

const deleteAdditionalNotice = ({ id }) => {
  return http.delete(`/gstr-config/additionalNotice/${id}`);
};

const completeTaskGstrOne = (data: any) => {
  return http.post(`/gstr-config/completeTaskGstrOne`, data);
};

export {
  exportdeletedGstClient,
  getGstrBulkSyncStatus,
  updateGstrEnableStatus,
  updateGstrDisableStatus,
  gstrScheduling,
  disableGstrClient,
  disableAtomProGstrClients,
  enableGstrClient,
  getDeletedGstrClients,
  getGstAtomClient,
  createNoticeAndOrder,
  createAdditionalNotice,
  completeTaskGstrOne,
  updateNoticeAndOrder,
  deleteNoticeAndOrder,
  updateAdditionalNotice,
  deleteAdditionalNotice,
};
